import { cn } from '@/utils/tailwind';

export const ProjectSidebarHeaderTag = (props: {
  show: boolean;
  text: string;
}) => {
  return (
    <div
      className={cn(
        'rounded-sm bg-quaternary p-0 px-1 text-xs font-medium',
        !props.show && 'hidden'
      )}
    >
      {props.text}
    </div>
  );
};
